import { schema } from 'normalizr';

export const suggestedFieldSchema = new schema.Entity('suggestedField');
